import React from "react";
import AppPage from "../pages/App";
import Login from "../pages/Login";
import RecipesPage from "../pages/RecipesPage";
import FiltersPage from "../pages/FiltersPage";
import SingleRecipePage from "../pages/SingleRecipePage";
import IngredientsPage from "../pages/IngredientsPage";
import AllergensPage from "../pages/AllergensPage";
import CategoriesPage from "../pages/CategoriesPage";
import UnitsPage from "../pages/UnitsPage";
import AlertsPage from "../pages/AlertsPage";
import GeneralInfoPage from "../pages/GeneralInfoPage";
import { Layout } from "../components/cecoadmin-panel";
import { Link } from "found";
import Redirect from "found/lib/Redirect";
import RedirectException from "found/lib/RedirectException";
import { isLoggedIn } from "../api/api";
import renderWithRootFragment from "./renderWithRootFragment";
import {
  generalInfoPageQuery,
  recipeQuery,
  recipesPageQuery,
  ingredientsPageQuery,
  allergensPageQuery,
  categoriesPageQuery,
  unitsPageQuery,
  alertsPageQuery,
  filtersPageQuery
} from "./queries";

const routes = [
  {
    path: "/",
    Component: AppPage,
    Link: Link,
    render: ({ Component, props, match }) => {
      const logged = isLoggedIn();

      const { pathname } = match.location;

      if (pathname !== "/login" && !logged) {
        throw new RedirectException("/login");
      } else if (pathname === "/login" && logged) {
        throw new RedirectException("/recipes");
      }
      return <Component {...props} />;
    },
    children: [
      new Redirect({ from: "/", to: "/login" }),
      { path: "login", Component: Login },
      {
        Component: Layout,
        children: [
          {
            path: "recipes",
            Component: RecipesPage,
            query: recipesPageQuery,
            render: renderWithRootFragment,
          },
          {
            path: "recipe/:id",
            Component: SingleRecipePage,
            prepareVariables: ({ id }) => {
              return { id: id };
            },
            query: recipeQuery,
            render: renderWithRootFragment,
          },
          {
            path: "ingredients",
            query: ingredientsPageQuery,
            Component: IngredientsPage,
            render: renderWithRootFragment,
          },
          {
            path: "allergens",
            query: allergensPageQuery,
            Component: AllergensPage,
            render: renderWithRootFragment,
          },
          {
            path: "categories",
            query: categoriesPageQuery,
            Component: CategoriesPage,
            render: renderWithRootFragment,
          },
          {
            path: "units",
            query: unitsPageQuery,
            Component: UnitsPage,
            render: renderWithRootFragment,
          },
          {
            path: "alerts",
            query: alertsPageQuery,
            Component: AlertsPage,
            render: renderWithRootFragment,
          },
          {
            path: "general-info",
            Component: GeneralInfoPage,
            query: generalInfoPageQuery,
          },
          {
            path: "filters",
            Component: FiltersPage,
            query: filtersPageQuery,
            render: renderWithRootFragment
          },
        ],
      },
    ],
  },
];

export default routes;
